<template>
    <v-group :config="{ listening: false }">

        <v-rect :config="backgroundFillRectConfig"></v-rect>

        <v-group v-if="gridDisplay">
            <v-line v-for="x in numberOfHorizontalLines"
                    :key="x"
                    :config="horizontalLineConfig(x)"
            ></v-line>

            <v-line v-for="y in numberOfVerticalLines"
                    :key="y"
                    :config="verticalLineConfig(y)"
            ></v-line>
        </v-group>

    </v-group>
</template>

<script>
    import { mapState } from 'vuex';

    const BackgroundFillColor = '#fff';
    const LineColor = '#bbb';

    export default {
        name: "BackgroundGrid",

        props: [
            'cellSize',
        ],

        computed: {
            ...mapState('editor', [
                'stageWidth',
                'stageHeight',
                'gridDisplay',
            ]),

            backgroundFillRectConfig() {
                return {
                    width: this.stageWidth,
                    height: this.stageHeight,
                    fill: BackgroundFillColor,
                }
            },

            numberOfHorizontalLines() {
                return Math.floor(this.stageWidth / this.cellSize)
            },

            numberOfVerticalLines() {
                return Math.floor(this.stageHeight / this.cellSize)
            },

        },

        methods: {
            horizontalLineConfig(n) {
                const x = n * this.cellSize;

                return {
                    points: [x, 0, x, this.stageHeight],
                    stroke: LineColor,
                    strokeWidth: 1,
                }
            },

            verticalLineConfig(n) {
                const y = n * this.cellSize;

                return {
                    points: [0, y, this.stageWidth, y],
                    stroke: LineColor,
                    strokeWidth: 1,
                }
            },

        },

    }
</script>

<style scoped>

</style>